export var ExperienceEnum;
(function (ExperienceEnum) {
    ExperienceEnum["Any"] = "any";
    ExperienceEnum["Junior"] = "junior";
    ExperienceEnum["Experienced"] = "experienced";
    ExperienceEnum["Senior"] = "senior";
})(ExperienceEnum || (ExperienceEnum = {}));
//# sourceMappingURL=experience.enum.js.map